import { FilterPipe } from './filter.pipe';
import { ReplacePipe } from './replace.pipe';
import { CapsPipe } from './caps.pipe';
import { RegNoPipe } from './regNo.pipe';
import { StringToInteger } from './stringtoDecimal';
import { MobileNo } from './mobile.pipe';
import { FindAMPMComponent } from './findAMPM.pipe';
import { ArrayObjectSort, JoinPipe,
    ArrayFilter, AwatarUri, DecimalToTime, FilterTablePipe, FindNamePipe, ReverseArrayPipe, SanitizeHtmlPipe, SanitizeUrlPipe, StringToNumber, Time24To12, TruncatePipe, ComplaintTypePipe, ObjHaveValue
} from './utility-pipes';
import { ArrayReversePipe } from './arrayReverse.pipe';
import { TimeAgoPipe } from './timeAgo.pipe';
import { BranchFilterPipe } from './branchFilter.pipe'
import { ShiftFilterPipe } from './shiftFilter.pipe';
import { ValueToPercentage } from './valueToPercentage'
import { RoundTo10 } from './roundTo10'
import { viewHourPipe } from './viewHour.pipe';
import { FieldMapPipe } from './fieldMap.pipe';
import { TripStatusLabelPipe } from './tripStatusLabel.pipe';



export const CustomPipes = [
    ArrayObjectSort, JoinPipe,
    ArrayFilter, AwatarUri, DecimalToTime, Time24To12, StringToNumber,SanitizeHtmlPipe,SanitizeUrlPipe,TimeAgoPipe,
    FilterPipe, ReplacePipe, CapsPipe, RegNoPipe, StringToInteger, MobileNo, ReverseArrayPipe, ArrayReversePipe, FindAMPMComponent,
    FindNamePipe,
    FilterTablePipe,
    BranchFilterPipe,ValueToPercentage,RoundTo10,
    ShiftFilterPipe,
    viewHourPipe,
    TruncatePipe,
    ComplaintTypePipe,
    ObjHaveValue,
    FieldMapPipe,
    TripStatusLabelPipe,
];

export const ProviderPipes = [
    FieldMapPipe
]
